import { styled, css } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { ellipsis, getMultilineTruncation } from '../../../../../play-core/styles/style-helper';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { SmartLink } from '../../../components/ClickableComponents/SmartLink';
import { TeaserLabel } from '../../../components/TeaserLabel/TeaserLabel';
export const searchResultPadding = css(["", "{padding:8px 8px;}", "{padding:8px 24px;}", "{padding:16px 32px;}"], Viewports.for('small'), Viewports.for('mediumUp'), Viewports.for('largeUp'));
export const ImageContainer = styled(SmartLink).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "MediaSearchResultstyles__ImageContainer",
  componentId: "sc-6ksf8o-0"
})(["display:flex;align-items:center;color:", ";position:relative;"], Colors.WHITE);
export const StyledMediaSearchResult = styled.article.withConfig({
  displayName: "MediaSearchResultstyles__StyledMediaSearchResult",
  componentId: "sc-6ksf8o-1"
})(["overflow-wrap:break-word;display:grid;align-items:start;grid-template-columns:auto 1fr;grid-column-gap:60px;background-color:", ";cursor:pointer;", " &:hover{background-color:", ";}", "{grid-column-gap:16px;}", "{margin-right:150px;}"], Colors.GREY_1a1a1a, searchResultPadding, Colors.GREY_2a2a2a, Viewports.for('small'), Viewports.for('xLargeUp'));
export const InfoContainer = styled.div.withConfig({
  displayName: "MediaSearchResultstyles__InfoContainer",
  componentId: "sc-6ksf8o-2"
})(["flex-grow:1;display:flex;flex-direction:column;width:100%;", "{padding-right:8px;}"], Viewports.for('small'));
export const DetailsContainer = styled.div.withConfig({
  displayName: "MediaSearchResultstyles__DetailsContainer",
  componentId: "sc-6ksf8o-3"
})(["display:grid;grid-template-columns:minmax(auto,max-content) min-content auto;color:", ";", ";line-height:28px;", "{", ";}"], Colors.GREY_969696, Fonts.regular(16), Viewports.for('small'), Fonts.medium(14));
export const ShowTitle = styled(SmartLink).withConfig({
  displayName: "MediaSearchResultstyles__ShowTitle",
  componentId: "sc-6ksf8o-4"
})(["color:", ";line-height:28px;", "{", "}"], Colors.GREY_969696, Viewports.for('small'), ellipsis);
export const Title = styled(SmartLink).withConfig({
  displayName: "MediaSearchResultstyles__Title",
  componentId: "sc-6ksf8o-5"
})(["", ";line-height:28px;margin-top:0;color:", ";", "{", ";flex-grow:1;", ";}", "{", ";}"], Fonts.medium(18), Colors.GREY_d2d2d2, Viewports.for('small'), Fonts.medium(16), getMultilineTruncation(2, 20), Viewports.for('mediumUp'), getMultilineTruncation(1, 28));
export const SearchTeaserLabel = styled(TeaserLabel).withConfig({
  displayName: "MediaSearchResultstyles__SearchTeaserLabel",
  componentId: "sc-6ksf8o-6"
})(["", "{display:none;}"], Viewports.for('small'));
export const Overlay = styled.div.withConfig({
  displayName: "MediaSearchResultstyles__Overlay",
  componentId: "sc-6ksf8o-7"
})(["display:flex;align-items:flex-start;position:absolute;top:0;left:0;bottom:0;right:0;"]);
export const MediaTypeOverlay = styled.div.withConfig({
  displayName: "MediaSearchResultstyles__MediaTypeOverlay",
  componentId: "sc-6ksf8o-8"
})(["pointer-events:none;position:absolute;color:", ";left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;", "{display:none;}"], Colors.WHITE, Viewports.for('small'));
export const MetaInformation = styled.div.withConfig({
  displayName: "MediaSearchResultstyles__MetaInformation",
  componentId: "sc-6ksf8o-9"
})(["margin-top:5px;display:flex;align-items:center;", ";line-height:28px;color:", ";", "{margin-top:0;}"], Fonts.light(12), Colors.GREY_d2d2d2, Viewports.for('small'));
export const Description = styled.div.withConfig({
  displayName: "MediaSearchResultstyles__Description",
  componentId: "sc-6ksf8o-10"
})(["color:", ";margin-top:16px;", ";", ";", "{display:none;}", "{", ";}"], Colors.GREY_d2d2d2, Fonts.light(18), getMultilineTruncation(3, 28), Viewports.for('small'), Viewports.for('medium'), getMultilineTruncation(2, 28));